export enum CustomerTypes {
  Business = 'business',
  Individual = 'individual',
  Agent = 'agent',
}
